(() => {
const enhance = function storefrontEnhance(scope = document) {
 const pages = [...scope.querySelectorAll('.bellzi-elements')].filter(page => !page.dataset.studioReady);
 if (!pages.length) return;
 pages.forEach(page => { page.dataset.studioReady = 'true'; });
 const find = selector => pages.flatMap(page => [...page.querySelectorAll(selector)]);
 find('[data-popup-open]').forEach(button => button.addEventListener('click', () => {
  const dialog = button.closest('.bellzi-elements').querySelector('[id="' + button.dataset.popupOpen.replace(/[^a-zA-Z0-9-]/g, '') + '"]');
  if (dialog && !dialog.open && typeof dialog.showModal === 'function') dialog.showModal();
 }));
 find('[data-popup-close]').forEach(button => button.addEventListener('click', () => button.closest('dialog')?.close()));
 const clocks = find('[data-countdown]').filter(clock => Number.isFinite(Date.parse(clock.dataset.countdown)));
 const tick = () => clocks.forEach(clock => {
  const seconds = Math.max(0, Math.floor((Date.parse(clock.dataset.countdown) - Date.now()) / 1000));
  clock.textContent = seconds > 0 ? Math.floor(seconds / 86400) + 'd ' + String(Math.floor(seconds / 3600) % 24).padStart(2, '0') + 'h ' + String(Math.floor(seconds / 60) % 60).padStart(2, '0') + 'm ' + String(seconds % 60).padStart(2, '0') + 's' : 'The wait is over';
 });
 if (clocks.length) {
  tick();
  if (clocks.some(clock => Date.parse(clock.dataset.countdown) > Date.now())) {
   const timer = setInterval(() => {
    tick();
    if (clocks.every(clock => !clock.isConnected || Date.parse(clock.dataset.countdown) <= Date.now())) clearInterval(timer);
   }, 1000);
  }
 }
 const root = window.Shopify?.routes?.root;
 if (typeof root !== 'string' || !/^\/(?!\/)[a-zA-Z0-9/_-]*$/.test(root)) return;
 const cache = new Map(), queue = [];
 let running = 0;
 const pump = () => {
  while (running < 4 && queue.length) {
   const {handle, resolve, reject} = queue.shift();
   running++;
   fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {credentials: 'same-origin'})
    .then(response => { if (!response.ok) throw Error('Product unavailable'); return response.json(); })
    .then(resolve, reject).finally(() => { running--; pump(); });
  }
 };
 const request = handle => {
  if (!cache.has(handle)) cache.set(handle, new Promise((resolve, reject) => { queue.push({handle, resolve, reject}); pump(); }));
  return cache.get(handle);
 };
 async function hydrate(card) {
  const handle = card.dataset.product, slot = card.querySelector('[data-quick-slot]');
  if (!slot || !/^[a-z0-9-]{1,120}$/.test(handle || '')) return;
  try {
   const product = await request(handle);
   const variants = (product.variants || []).filter(variant => variant.available && /^\d+$/.test(String(variant.id)));
   if (!product.available || !variants.length) { slot.textContent = 'Resting for now'; return; }
   const form = document.createElement('form');
   form.action = root + 'cart/add'; form.method = 'post';
   const variant = document.createElement(variants.length > 1 ? 'select' : 'input');
   variant.name = 'id';
   if (variants.length > 1) {
    variant.setAttribute('aria-label', 'Choose an option for ' + product.title);
    variants.forEach(item => { const option = document.createElement('option'); option.value = String(item.id); option.textContent = item.public_title || item.title; variant.append(option); });
   } else { variant.type = 'hidden'; variant.value = String(variants[0].id); }
   form.append(variant);
   const qty = document.createElement('input'); qty.type = 'hidden'; qty.name = 'quantity'; qty.value = '1'; form.append(qty);
   const button = document.createElement('button'); button.type = 'submit'; button.textContent = 'Add to bag'; button.setAttribute('aria-label', 'Add ' + product.title + ' to bag'); form.append(button);
   const status = document.createElement('span'); status.setAttribute('role', 'status'); status.className = 'be-cart-status'; form.append(status);
   form.addEventListener('submit', async event => {
    event.preventDefault();
    if (button.disabled) return;
    button.disabled = true; button.textContent = 'Adding…'; status.textContent = '';
    try {
     const selected = variants.find(item => String(item.id) === variant.value);
     if (!selected) throw Error('Choose an available option.');
     const response = await fetch(root + 'cart/add.js', {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: [{id: selected.id, quantity: 1}]})});
     let result;
     try { result = await response.json(); } catch { throw Error('We could not confirm this addition. Check your bag before trying again.'); }
     if (!response.ok) throw Error(result.description || 'Unable to add this friend. Please try again.');
     button.textContent = 'Added to bag'; status.textContent = 'Added. Opening your bag…'; window.location.assign(root + 'cart');
    } catch (error) {
     button.disabled = false; button.textContent = 'Add to bag'; status.textContent = error.message || 'Check your bag before trying again.';
    }
   });
   slot.replaceChildren(form);
  } catch {
   // Preserve the existing product link when the product request fails.
   const status = document.createElement('span'); status.className = 'be-cart-status'; status.setAttribute('role', 'status'); status.textContent = 'Visit the product for availability.'; slot.append(status);
  }
 }
 const cards = find('[data-product]');
 if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver(entries => { for (const entry of entries) if (entry.isIntersecting) { observer.unobserve(entry.target); hydrate(entry.target); } }, {rootMargin: '250px'});
  cards.forEach(card => observer.observe(card));
 } else cards.forEach(hydrate);
};
const run = () => document.querySelectorAll('[data-bellzi-studio-page]').forEach(enhance);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, {once: true}); else run();
document.addEventListener('shopify:section:load', run);
})();
